import { render } from "./sMIRResult.vue?vue&type=template&id=0d601866&scoped=true"
import script from "./sMIRResult.vue?vue&type=script&lang=js"
export * from "./sMIRResult.vue?vue&type=script&lang=js"

import "./sMIRResult.vue?vue&type=style&index=0&id=0d601866&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d601866"]])

export default __exports__